module.exports = __webpack_public_path__ + "static/media/bg-download.8e9d7ad2.png";